import accordionButtons from "./accordionButtons";
import eventListener from "./eventListener";
import selectFields from "./selectFields";
import cloneProduct from "./cloneProduct";
import cleanErrors from "./cleanErrors";
import removeItem from "./removeItem";
import modals from "./modals";
import submit from "./submit";
import $ from "jquery";
import userModal from "./userModal";
import backButton from "./backButton";

export default function () {
    if (!$('body').hasClass('products')) {
        return false;
    }

    window.addEventListener("pageshow", function (event) {
        var historyTraversal = event.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2);
        if (historyTraversal) {
            // Handle page restore.
            window.location.reload(true);
        }
    });

    window.lastProduct = 0;

    backButton();
    accordionButtons();
    eventListener();
    selectFields();
    cloneProduct();
    cleanErrors();
    removeItem();
    modals();
    submit();

    window.$registrationData = null;
    $.ajax({
        url: loadRegistrationDataUrl,
        method: "POST",
        success: function (result) {
            window.$registrationData = result;
            updateUserData();
        }
    });

    userModal();
}

export function updateUserData() {
    $('#contact-data').find('[data-field="name"]').html(window.$registrationData.user['name'] + " " + window.$registrationData.user['surname']);
    $('#contact-data').find('[data-field="address"]').html(
        window.$registrationData.user['address'] + "<br>" +
        window.$registrationData.user['cap'] + " - " + window.$registrationData.user['city']
        + " " +
        (typeof window.$registrationData.user['provincia'] !== "undefined" && window.$registrationData.user['provincia'] && window.$registrationData.user['country'] === 'Italy' ? "(" + window.$registrationData.user['provincia'] + ")" : "")
        + "<br>" +
        window.$registrationData.user['country']
    );
    $('#contact-data').find('[data-field="email"]').html(window.$registrationData.user['email']);
    $('#contact-data').find('[data-field="phone"]').html(window.$registrationData.user['phone']);
}
